import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

const useStyles = makeStyles({
	progressBar: {
		width: '200px',
	},
	flex: {
		display: 'flex',
		...shorthands.gap('8px'),
		alignItems: 'center',
	},
	marginTop: {
		...shorthands.margin('8px', 0, 0, 0),
	},
	justifyContentStart: {
		justifyContent: 'flex-start',
	},
	iconColorSize: {
		fontSize: '16px',
		color: tokens.colorBrandStroke1,
	},
});

export default useStyles;
